// extracted by mini-css-extract-plugin
export default {"mainTitle":"Leaderboards_mainTitle__qoJ0j"};